import type { RdvFormData, RdvFormErrors, Slot } from "./_types"

export function validateStep1(form: RdvFormData, isPro: boolean): RdvFormErrors {
  const errs: RdvFormErrors = {}
  if (isPro) {
    if (!form.companyName.trim()) errs.companyName = "Requis"
  } else {
    if (!form.firstName.trim()) errs.firstName = "Requis"
    if (!form.lastName.trim()) errs.lastName = "Requis"
  }
  if (!form.phone.trim() || !/^(\+33|0)[1-9]\d{8}$/.test(form.phone.replace(/\s/g, "")))
    errs.phone = "Numéro invalide"
  if (!form.address.trim()) errs.address = "Requis"
  if (!form.type) errs.type = "Choisissez un type"
  if (!form.consent) errs.consent = "Requis"
  return errs
}

// Filtre selon la journée résidence sélectionnée puis regroupe par jour
export function groupSlotsByDay(
  slots: Slot[],
  residenceDayFilter: string | null
): Record<string, Slot[]> {
  const visible = residenceDayFilter ? slots.filter((s) => s.dayKey === residenceDayFilter) : slots
  const byDay: Record<string, Slot[]> = {}
  for (const slot of visible) {
    if (!byDay[slot.dayKey]) byDay[slot.dayKey] = []
    byDay[slot.dayKey].push(slot)
  }
  return byDay
}
